<template>
  <div class="table-custom" v-if="tableData.length">
    <table>
      <thead>
        <!-- categories header -->
        <tr class="categories-header">
          <th
            v-for="(item, index) in headers"
            :key="item + index"
            :rowspan="2"
            :colspan="item.count || 1"
          >
            <div
              class="header-fixed flex w-full h-full items-end justify-center"
            >
              <div class="font-bold px-2">
                {{ item.count ? item.name : $t("class." + item.name) }}
              </div>
            </div>
          </th>
          <!-- Extra coursework-->
          <th
            v-if="columns.length"
            :colspan="tableData[0].activities.length + 1"
          >
            <div class="p-3 font-bold">
              {{ $t("class.score_synced") }} ({{ weightOfLms }}%)
            </div>
          </th>
          <th
            v-for="(category, index) in categoryData"
            :key="'activity' + index"
            :colspan="category.activity_class_lms.length"
          >
            <div class="py-3 font-bold">
              {{ category.name }} ({{ category.weight }}%)
            </div>
          </th>
        </tr>
        <!-- categories header -->

        <!-- activities header -->
        <tr class="activities-header-lms">
          <th v-if="columns.length">
            <div class="flex justify-center py-3 mx-auto w-[160px]">
              <span class="font-bold ">{{ $t("class.final_score_lms") }}</span>
            </div>
          </th>
          <th v-for="(column, index) in columns" :key="column + index + 'lms'">
            <div class="font-bold mx-auto py-3">
              <md-tooltip
                md-direction="top"
                :class="hiddenTooltip(column.name, subName(column.name, 14))"
                >{{ column.name }}
              </md-tooltip>
              <p class="w-full px-1 font-bold">
                {{ subName(column.name, 14) }}
              </p>
            </div>
          </th>
          <!-- Extra coursework-->
          <th
            v-for="(activity, index) in activityList"
            :key="activity + index + 'extra'"
          >
            <div class="font-bold py-3 w-full">
              <md-tooltip
                md-direction="top"
                :class="
                  hiddenTooltip(activity.name, subName(activity.name, 14))
                "
                >{{ activity.name }}
              </md-tooltip>
              <a
                class="cursor-pointer px-1 underline text-[#000]"
                @click="setEditActivityLmsModal(activity)"
              >
                {{ subName(activity.name, 14) }}
              </a>
            </div>
          </th>
        </tr>
        <!-- activities header -->

        <!-- Render Average row -->
        <tr class="bg-[#f1f1f1]">
          <td
            v-for="(field, indexField) in fixedFields"
            :key="indexField"
            class="bg-[#f1f1f1]"
          >
            <div v-if="field === 'student'" class=" font-bold center-item">
              {{ $t("class.average") }}
            </div>
            <div class="flex justify-center">
              <span
                class="font-bold"
                :class="{
                  'center-item': !checkFieldValid(field)
                }"
                v-html="renderCell(avgScore[field])"
              ></span>
              <p>
                {{ checkFieldValid(field) ? "%" : "" }}
              </p>
            </div>
          </td>
          <td v-if="columns.length">
            <div v-html="renderCell(avgScore['final_score'])"></div>
          </td>
          <td v-for="(column, index) in columns" :key="column + index">
            <div
              class="font-bold"
              v-html="renderCell(avgScore[column.external_id])"
            ></div>
          </td>
          <td v-for="(item, index) in activityList" :key="'avg' + index">
            <div class="font-bold" v-html="renderCell(avgScore[item.id])"></div>
          </td>
        </tr>
        <!-- Render Average row -->
      </thead>

      <tr
        class="render-fixed-field"
        v-for="(item, index) in tableData"
        :key="item + index"
      >
        <!-- render fixed field -->
        <td v-for="(field, indexField) in fixedFields" :key="indexField">
          <span v-html="renderCell(item[field])"></span>
          <span>{{ checkFieldValid(field) ? "%" : "" }}</span>
        </td>
        <!-- render fixed field -->

        <!-- render data -->
        <!--final score lms-->
        <td v-if="columns.length">
          <div class="flex justify-center py-3 mx-auto w-[160px]">
            <span>{{ item.final_score }}</span>
          </div>
        </td>
        <!-- score lms-->
        <td v-for="(value, idx) in item.activities" :key="idx + value">
          <div class="flex justify-center">
            <div>
              <span>{{ value.percentage_score || 0 }} </span>
              <span>
                {{ lmsName === "agilix" ? " %" : "" }}
              </span>
            </div>
          </div>
        </td>
        <!-- score extra coursework-->
        <td
          v-for="(score, index) in item.score_extra"
          :key="'score extra' + index"
        >
          <div class="flex justify-center pr-5 min-w-[150px]">
            <input
              type="number"
              class="underline"
              :class="getClassError(score.score.score, score.max_point)"
              v-model="score.score.score"
            />/
            {{ score.max_point }}
          </div>
        </td>
        <!-- render data -->
      </tr>
    </table>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
const defaultLmsName = "Scores synced from LMS system";
export default {
  name: "ScoreTable",
  props: [
    "columns",
    "headerColumns",
    "tableData",
    "avgScore",
    "status",
    "isLmsSystem",
    "lmsName"
  ],
  inject: ["setEditActivityLmsModal"],
  data() {
    return {
      categoryData: [],
      activityList: [],
      defaultScoreExtra: [],
      tableDataDefaul: [],
      weightOfLms: null,
      hasScoreExtra: null,
      fixedFields: []
    };
  },
  computed: {
    isShowFinalScoreAndGradeLetter() {
      return this.status === "Concluded";
    },
    headers() {
      if (this.isShowFinalScoreAndGradeLetter) {
        return this.headerColumns;
      }
      return this.headerColumns.filter(item => {
        return (
          item.name !== "grade_letter" && item.name !== "final_score_coursework"
        );
      });
    }
  },
  watch: {
    tableData: function() {
      this.setupTable();
    }
  },
  created() {
    this.setupTable();
  },
  methods: {
    checkFieldValid(field) {
      return field === "current_score" || field === "current_score_coursework";
    },
    getClassError(score, maxPoint) {
      return +score > +maxPoint ? "text-red-500" : "";
    },
    setupTable() {
      this.tableDataDefaul = cloneDeep(this.tableData);
      const categoryData = this.tableData[0].class_activity_categories;
      this.weightOfLms = categoryData.find(
        item => item.name === defaultLmsName
      )?.weight;
      this.categoryData = categoryData.filter(
        item => item.activity_class_lms?.length
      );
      this.activityList = this.categoryData
        .map(item => item.activity_class_lms)
        .flat();
      this.show();
      this.setFixedField(this.activityList);
    },
    setFixedField() {
      this.hasScoreExtra = +this.weightOfLms > 0;
      if (this.hasScoreExtra) {
        this.fixedFields = [
          "student",
          "final_score_coursework",
          "grade_letter_coursework",
          "current_score_coursework"
        ];
        if (!this.isShowFinalScoreAndGradeLetter) {
          this.fixedFields = ["student", "current_score_coursework"];
        }
        return;
      }
      this.fixedFields = [
        "student",
        "final_score",
        "grade_letter",
        "current_score"
      ];
      if (!this.isShowFinalScoreAndGradeLetter) {
        this.fixedFields = ["student", "current_score"];
      }
    },
    show() {
      this.tableData.forEach(data => {
        data.score_extra = data.class_activity_categories
          .map(item => item.activity_class_lms)
          .flat();
      });
      this.defaultScoreExtra = cloneDeep(this.tableData.score_extra);
    },
    subName(name, maxLength) {
      if (name.length > maxLength) {
        return name.slice(0, 14) + (name.length > maxLength ? "..." : "");
      }
      return name;
    },
    hiddenTooltip(oldName, newName) {
      return oldName === newName ? "hidden" : "";
    },
    renderCell(value) {
      if (value instanceof Array) return cellVal.join(", ");
      const score = +value > 0 ? (+value).toFixed(2) : value;
      return score;
    }
  }
};
</script>
<style lang="scss" scoped>
.table-custom {
  overflow: scroll;
  max-height: 750px;
  table,
  td,
  th {
    table-layout: fixed;
    box-shadow: 0 0 0 0.6px black inset;
    text-align: center;
  }
  th {
    top: 0;
    z-index: 2;
    background: #f1f1f1;
    padding: 0;
  }
  table {
    min-width: 1024px;
    td:nth-child(1) {
      min-width: 250px;
      background: #ffffff;
      position: sticky;
      left: 0;
      div {
        position: relative;
        text-align: left;
      }
    }
    thead {
      position: sticky;
      top: 0;
      z-index: 2;
      .categories-header {
        th {
          top: 0;
          z-index: 2;
          div {
            min-width: 80px;
          }
        }
        th:nth-child(1) {
          min-width: 250px;
          background: #f1f1f1;
          position: sticky;
          left: 0;
          div {
            position: relative;
            text-align: left;
          }
        }
      }
      .activities-header-lms {
        th {
          div {
            width: 150px;
          }
        }
      }
    }
  }
  .font-bold {
    font-weight: 500 !important;
    font-size: 1rem;
    display: flex;
    justify-content: center;
  }
}
::-webkit-scrollbar {
  appearance: none;
  width: 10px;
  height: 10px;
}
@media (max-width: 599px) {
  .table-custom {
    table {
      td:nth-child(1) {
        position: static !important;
      }
      thead {
        position: static !important;
        .categories-header {
          th:nth-child(1) {
            position: static !important;
          }
        }
      }
    }
  }
}
::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 25px;
}
input {
  text-align: right;
  max-width: 38px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
